function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_1537_132)"
}, React.createElement("path", {
  d: "M19.35 6.22633C18.67 2.81758 15.64 0.258545 12 0.258545C9.11 0.258545 6.6 1.87894 5.35 4.25024C2.34 4.56642 0 7.08593 0 10.139C0 13.4094 2.69 16.0672 6 16.0672H19C21.76 16.0672 24 13.854 24 11.127C24 8.40003 21.95 6.40418 19.35 6.22633ZM17 9.15094L12 14.0912L7 9.15094H10V5.19876H14V9.15094H17Z"
}));

var SvgIconDownload = function SvgIconDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconDownload.f1df1dcf.svg";
export { ForwardRef as ReactComponent };